[
    {
        "category": "😊 I Love You",
        "folder": "b",
        "count": 5
    },
    {
        "category": "🔥 You've Got This!",
        "folder": "c",
        "count": 5
    },
    {
        "category": "😂 LOL",
        "folder": "d",
        "count": 6
    },
    {
        "category": "🎯 Bullseye",
        "folder": "e",
        "count": 2
    },
    {
        "category": "🎉 Congrats",
        "folder": "f",
        "count": 2
    },
    {
        "category": "🥹 Awwee",
        "folder": "g",
        "count": 6
    },
    {
        "category": "😮 OMG",
        "folder": "h",
        "count": 8
    },
    {
        "category": "🤤 Yummy",
        "folder": "a",
        "count": 7
    },
    {
        "category": "🙏🏼 Sending Prayers",
        "folder": "i",
        "count": 3
    },
    {
        "category": "😭 I'm Sorry",
        "folder": "j",
        "count": 3
    },
    {
        "category": "🥺 Please Forgive Me",
        "folder": "k",
        "count": 4
    },
    {
        "category": "🎂 Happy Birthday",
        "folder": "l",
        "count": 3
    },
    {
        "category": "💝 Happy Valentine's Day",
        "folder": "m",
        "count": 3
    },
    {
        "category": "👩 Happy Mother's Day",
        "folder": "n",
        "count": 3
    },
    {
        "category": "👨 Happy Father's Day",
        "folder": "o",
        "count": 3
    },
    {
        "category": "🎄 Merry Christmas",
        "folder": "p",
        "count": 4
    },
    {
        "category": "🎊 Happy New Year",
        "folder": "q",
        "count": 7
    },
    {
        "category": "🥂 Happy Anniversary",
        "folder": "r",
        "count": 4
    }
]
